interface RatingStarsProps {
  rating: number;
  size?: 'sm' | 'md' | 'lg';
  showValue?: boolean;
}

export default function RatingStars({ rating, size = 'md', showValue = true }: RatingStarsProps) {
  const starCount = 5;
  const fullStars = Math.floor(rating / 2);
  const hasHalf = rating / 2 - fullStars >= 0.5;

  const sizeClasses = {
    sm: 'text-xs gap-0.5',
    md: 'text-sm gap-0.5',
    lg: 'text-base gap-1',
  };

  return (
    <div className={`flex items-center ${sizeClasses[size]}`}>
      {Array.from({ length: starCount }, (_, i) => {
        if (i < fullStars) {
          return <i key={i} className="ri-star-fill text-accent-500"></i>;
        }
        if (i === fullStars && hasHalf) {
          return <i key={i} className="ri-star-half-fill text-accent-500"></i>;
        }
        return <i key={i} className="ri-star-line text-foreground-300"></i>;
      })}
      {showValue && (
        <span className="ml-1.5 text-foreground-600 font-medium">{rating}</span>
      )}
    </div>
  );
}